import React from 'react';
import { trackAddToCart } from '../utils/fbpixel';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  fullWidth = false,
  href
}: CTAButtonProps) {
  const isExternal = !!href;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isExternal) {
      e.preventDefault();
      const target = document.getElementById('precio-final');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      trackAddToCart({
        content_name: 'Ciática SOS',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    onClick?.();
  };
  return <a href={isExternal ? href : '#precio-final'} onClick={handleClick} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`
        group relative inline-flex items-center justify-center gap-3 
        bg-orange-500 hover:bg-orange-600 text-white 
        font-extrabold text-lg md:text-xl lg:text-2xl
        py-4 md:py-5 px-8 md:px-12 rounded-xl
        shadow-[0_0_20px_rgba(249,115,22,0.4)] hover:shadow-[0_0_30px_rgba(249,115,22,0.6)]
        transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]
        uppercase tracking-wide cursor-pointer no-underline
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-30">
      {/* Subtle pulse ring */}
      <span className="absolute inset-0 rounded-xl ring-4 ring-orange-500/30 animate-pulse" data-id="element-31"></span>

      <span className="relative z-10 flex items-center gap-2 text-center" data-id="element-32">
        {children}
        <ArrowRight className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-1 transition-transform" data-id="element-33" />
      </span>
    </a>;
}